import DOMPurify from 'dompurify'

/** Sanitize untrusted HTML — strips scripts, event handlers, iframes. */
export function sanitizeHtml(dirty: string | undefined | null): string {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty)
}

/** Sanitize embed HTML — allows iframes (quiz/journey slide embeds from admin). */
export function sanitizeEmbedHtml(dirty: string | undefined | null): string {
  if (!dirty) return ''
  return DOMPurify.sanitize(dirty, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'loading', 'src'],
  })
}
